import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CleanTreeService from './pages/Home';
import About from './pages/About';
import Services from './pages/Service';
import TreeServiceLinktree from './components/TreeServiceLinktree';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ServiceArea from './pages/ServiceArea';
import ServicePage from './pages/ServicePage';
import { SERVICE_PAGES } from './servicePages';

// Routes live apart from App so the prerender script can mount them inside a
// StaticRouter. App itself supplies BrowserRouter, which can't render on the
// server.
const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<CleanTreeService />} />
    <Route path="/about" element={<About />} />
    <Route path="/services" element={<Services />} />
    <Route path="/links" element={<TreeServiceLinktree />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/terms" element={<Terms />} />
    {/* Service landing pages — see src/servicePages.js */}
    {SERVICE_PAGES.map(page => (
      <Route key={page.slug} path={`/${page.slug}`} element={<ServicePage slug={page.slug} />} />
    ))}
    {/* Town-level landing pages — see src/serviceAreas.js */}
    <Route path="/tree-service/:slug" element={<ServiceArea />} />
  </Routes>
);

export default AppRoutes;
